import "markdown-it";
import "markdown-it-html5-embed";

import "../stylesheets/markdown_editor";

window.addEventListener("load", function() {

const md = require("markdown-it")({ breaks: true }).use(require("markdown-it-html5-embed"), {
  html5embed: {
    useImageSyntax: true, // Enables video/audio embed with ![]() syntax (default)
    useLinkSyntax: true,
    isAllowedHttp: true
  }
});

const styles = '<style>body { font-family: sans-serif; }</style>';


  const source = document.getElementById('markdown-source');
  const markdown_target = document.getElementById('markdown-target');
  markdown_target.innerHTML = md.render(source.innerHTML);
});
